var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout-attente"}},[_c('TopBar'),_c('Notification'),_c('AppHeaderCheckout'),_vm._t("default"),_c('AppFooterAttente')],2)}
var staticRenderFns = []

export { render, staticRenderFns }